import React from "react";
import Card from "../ui/Card";
import Skeleton from "../ui/Skeleton";

export const EbookListSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse">
      {/* 1. Filter Bar Skeleton - full-bleed sticky bar, mesmo padrão de "Postagens" */}
      <div className="-mt-4 -mx-2 pl-4 pr-2 xl:pl-5 xl:pr-3 py-1.5 border-b border-purple-200 bg-white/95 flex flex-col gap-3">
        <div className="flex flex-row flex-wrap gap-2 sm:gap-2.5 items-center">
          {/* Search */}
          <div className="flex-1 min-w-[200px] sm:min-w-[250px]">
            <Skeleton
              variant="rectangular"
              width="100%"
              height={36}
              className="rounded-xl opacity-30"
            />
          </div>

          {/* Filters Selects — size="sm" do Select real usa h-10 (40px) */}
          <div className="flex flex-wrap items-center gap-2">
            <Skeleton
              variant="rectangular"
              width={175}
              height={40}
              className="rounded-xl opacity-30 shrink-0"
            />
            <Skeleton
              variant="rectangular"
              width={180}
              height={40}
              className="rounded-xl opacity-30 shrink-0"
            />
            <Skeleton
              variant="rectangular"
              width={160}
              height={40}
              className="rounded-xl opacity-30 shrink-0"
            />
          </div>
        </div>
      </div>

      {/* 2. Ebook Grid Skeleton - Sincronizado com EbookList.tsx */}
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <Card
            key={i}
            className="group relative flex flex-col h-full bg-white border border-purple-200 rounded-2xl p-0 overflow-hidden shadow-xs shadow-purple-500/5"
          >
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-purple-100/50" />

            <div className="p-3.5 flex flex-col h-full gap-3 relative">
              {/* Card Header */}
              <div className="flex items-start gap-2.5">
                <Skeleton
                  variant="rectangular"
                  width={44}
                  height={44}
                  className="rounded-xl shrink-0 bg-gray-100 shadow-xs"
                />
                <div className="flex-1 min-w-0 pt-0.5 space-y-2">
                  <div className="flex gap-1.5">
                    <Skeleton
                      variant="rectangular"
                      width={70}
                      height={16}
                      className="rounded-lg bg-purple-50"
                    />
                    <Skeleton
                      variant="rectangular"
                      width={60}
                      height={16}
                      className="rounded-lg bg-gray-50"
                    />
                  </div>
                  <Skeleton
                    variant="text"
                    width="90%"
                    height="1.1rem"
                    className="bg-gray-200"
                  />
                  <Skeleton
                    variant="text"
                    width="60%"
                    height="1.1rem"
                    className="bg-gray-200"
                  />
                </div>
              </div>

              {/* Description area */}
              <div className="flex-1 bg-gray-50/50 p-3 rounded-xl border border-purple-200/50 space-y-2">
                <Skeleton variant="text" width="100%" height="0.65rem" />
                <Skeleton variant="text" width="95%" height="0.65rem" />
                <Skeleton variant="text" width="70%" height="0.65rem" />
              </div>

              {/* Metrics Footer — mesma borda divisória do EbookCard real */}
              <div className="flex flex-col gap-3 pt-3.5 border-t border-purple-200">
                <div className="flex items-center justify-between">
                  <Skeleton
                    variant="rectangular"
                    width={60}
                    height={20}
                    className="rounded-lg bg-gray-50"
                  />
                  <div className="flex gap-1.5">
                    <Skeleton
                      variant="rectangular"
                      width={45}
                      height={20}
                      className="rounded-lg bg-blue-50/50"
                    />
                    <Skeleton
                      variant="rectangular"
                      width={45}
                      height={20}
                      className="rounded-lg bg-emerald-50/50"
                    />
                  </div>
                </div>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={32}
                  className="rounded-lg bg-purple-50"
                />
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* 3. Pagination Skeleton */}
      <div className="mt-10 flex justify-center w-full">
        <Skeleton
          variant="rectangular"
          width={450}
          height={48}
          className="rounded-2xl bg-white shadow-xs border border-purple-50"
        />
      </div>
    </div>
  );
};

export default EbookListSkeleton;
